// Scroll-triggered section animations. An IntersectionObserver reveals each
// .animation-wrapper's elements as the wrapper enters the viewport — this
// replaces the old scroll-polling loop and its fixed 1-1.5s delay, which
// made every section feel slow to appear. A per-wrapper MutationObserver
// covers content swapped into an already-visible wrapper (collection
// filters, recommended products, the theme editor).
var animationObserver = null;
var observedAnimationWrappers = typeof Set === 'function' ? new Set() : null;
var visibleAnimationWrappers = typeof WeakSet === 'function' ? new WeakSet() : null;
var animationWrapperMutations = typeof WeakMap === 'function' ? new WeakMap() : null;

function revealAnimationElements(wrapper){
    var reveal = function(){
        wrapper.querySelectorAll('.animation-element').forEach(function(el){
            el.classList.add('in-view');
        });
    };
    if('requestAnimationFrame' in window){
        // Two frames: content swapped into the DOM in this same task must
        // paint its hidden initial state once, or the browser skips the
        // transition and the section pops in with no animation.
        requestAnimationFrame(function(){ requestAnimationFrame(reveal); });
    }else{
        reveal();
    }
}

function watchAnimationWrapperContent(wrapper){
    if(!('MutationObserver' in window) || !animationWrapperMutations || animationWrapperMutations.has(wrapper)) return;
    var mutationObserver = new MutationObserver(function(){
        // Replaced children (filtered product grids, fetched sections)
        // arrive hidden inside a wrapper that is already intersecting, so
        // the IntersectionObserver fires no new entry for them. Reveal them
        // here when the wrapper is on screen; off-screen wrappers are
        // handled by the observer on their next entry.
        if(visibleAnimationWrappers && visibleAnimationWrappers.has(wrapper) &&
            wrapper.querySelector('.animation-element:not(.in-view)')){
            revealAnimationElements(wrapper);
        }
    });
    mutationObserver.observe(wrapper, { childList: true, subtree: true });
    animationWrapperMutations.set(wrapper, mutationObserver);
}

function observeAnimationWrappers(){
    if(!('IntersectionObserver' in window)) return;
    if(!animationObserver){
        animationObserver = new IntersectionObserver(function(entries){
            entries.forEach(function(entry){
                if(entry.isIntersecting){
                    if(visibleAnimationWrappers) visibleAnimationWrappers.add(entry.target);
                    // Only re-run the reveal when something is still hidden.
                    if(entry.target.querySelector('.animation-element:not(.in-view)')){
                        revealAnimationElements(entry.target);
                    }
                }else if(visibleAnimationWrappers){
                    visibleAnimationWrappers.delete(entry.target);
                }
            });
        }, { rootMargin: '0px 0px -10% 0px' });
    }
    // Drop wrappers detached by theme-editor section re-renders so the
    // observers do not accumulate dead subtrees over an editing session.
    if(observedAnimationWrappers){
        observedAnimationWrappers.forEach(function(wrapper){
            if(wrapper.isConnected) return;
            animationObserver.unobserve(wrapper);
            observedAnimationWrappers.delete(wrapper);
            if(visibleAnimationWrappers) visibleAnimationWrappers.delete(wrapper);
            var mutationObserver = animationWrapperMutations && animationWrapperMutations.get(wrapper);
            if(mutationObserver){
                mutationObserver.disconnect();
                animationWrapperMutations.delete(wrapper);
            }
        });
    }
    document.querySelectorAll('.animation-wrapper').forEach(function(wrapper){
        if(observedAnimationWrappers){
            if(observedAnimationWrappers.has(wrapper)) return;
            observedAnimationWrappers.add(wrapper);
        }
        animationObserver.observe(wrapper);
        watchAnimationWrapperContent(wrapper);
    });
}

// Also called directly by theme-editor.js after section changes, and used as
// the scroll handler on browsers without IntersectionObserver: registers any
// new wrappers and reveals the ones already on screen, with no delay.
function onVisibilityChange(){
    observeAnimationWrappers();
    document.querySelectorAll('.animation-wrapper').forEach(function(item){
        if(isPartialElementInViewport(item)){
            revealAnimationElements(item);
        }
    });
}

// Non-jQuery
if (window.addEventListener) {

    if('IntersectionObserver' in window){
        // Start at window load, when the theme's full-page loading overlay
        // (body[data-loaded]) lifts: the observer fires immediately for
        // wrappers already in view, so the first sections animate right as
        // the page is revealed instead of finishing behind the overlay.
        if(document.readyState === 'complete'){
            observeAnimationWrappers();
        }else{
            window.addEventListener('load', observeAnimationWrappers, false);
        }
    }else{
        document.addEventListener('DOMContentLoaded', onVisibilityChange, false);
        document.addEventListener('load', onVisibilityChange, false);
        document.addEventListener('scroll', onVisibilityChange, false);
        document.addEventListener('resize', onVisibilityChange, false);
    }

    if(document.querySelectorAll('.parallax-wrapper').length > 0){
        document.addEventListener('DOMContentLoaded', parallaxEffect, false);
        document.addEventListener('load', parallaxEffect, false);
        document.addEventListener('scroll', parallaxEffect, false);
        document.addEventListener('resize', parallaxEffect, false);
    }

    document.addEventListener('DOMContentLoaded', adjustMainMinHeight);

} else if (window.attachEvent)  {

    attachEvent('onDOMContentLoaded', onVisibilityChange); // Internet Explorer 9+ :(
    attachEvent('onload', onVisibilityChange);
    attachEvent('onscroll', onVisibilityChange);
    attachEvent('onresize', onVisibilityChange);

    if(document.querySelectorAll('.parallax-wrapper').length > 0){
        attachEvent('DOMContentLoaded', parallaxEffect);
        attachEvent('load', parallaxEffect);
        attachEvent('scroll', parallaxEffect);
        attachEvent('resize', parallaxEffect);
    }

    attachEvent('onDOMContentLoaded', adjustMainMinHeight)

}

function adjustMainMinHeight(){
    var footer = document.querySelector('custom-footer');

    if(footer){
        var footerHeight = footer.offsetHeight;
        document.querySelector('#main').style.minHeight = `calc(100vh - ${ footerHeight }px)`;
    }
}

function parallaxEffect(){
    document.querySelectorAll('.parallax-wrapper').forEach((item) => {

        var rect = item.getBoundingClientRect();
        if(rect.top <= (window.innerHeight || document.documentElement.clientHeight) && rect.bottom >= 0){
            var pos = rect.top / (rect.bottom - rect.top) + 1;
            item.querySelectorAll('.parallax-element').forEach((elem) => {
                elem.style.transform = `translateY(-${pos * 10}%)`
            })
        }

    })
}

function isElementInViewport (el) {
    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    );
}

function isPartialElementInViewport (el) {
    var rect = el.getBoundingClientRect();

    return (
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) ||
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
}

function fetchConfig(type = 'json'){
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
}

function arraysEqual(a1,a2) {
    /* WARNING: arrays must not contain {objects} or behavior may be undefined */
    return JSON.stringify(a1)==JSON.stringify(a2);
}

if(!customElements.get('custom-accordion')){
    class CustomAccordion extends HTMLElement {
        constructor(){
            super();
    
            this.init();
        }
    
        init(){
            this.text = this.querySelector('.accordion-text');
            this.textInner = this.text.querySelector('.accordion-text__inner');
            this.remainOpen = this.getAttribute('data-remain-open') == 'true'? true : false;
    
            var ifOpened = this.getAttribute('data-open') == 'true'? true : false;
            if(ifOpened){
                this.textHeight = this.textInner.clientHeight;
                this.text.style.height = `calc(${this.textHeight}px + var(--accordion-extra-space, 2rem))`;
            }else{
                this.textHeight = 0;
                this.text.style.height = `${this.textHeight}px`;
            }
    
            this.addEventListener('click', this.openAccordion.bind(this));
            this.addEventListener('keydown', e => {
                // check if checkbox clicked
                if(e.target.classList.contains('checkbox')) return;

                if(e.key === 'Enter'){
                    this.openAccordion(e);
                }
            })
        }
    
        openAccordion(e){
            var ifOpened = this.getAttribute('data-open') == 'true'? true : false;
            if(ifOpened && (!this.remainOpen || e.target.classList.contains('accordion-heading') || e.target.closest('.accordion-heading'))){ 
                // close the accordion
                this.setAttribute('data-open', 'false');
                this.setAccordionTextHeight();

                this.querySelectorAll('input').forEach(item => {
                    item.setAttribute('tabindex', '-1');
                })
            }else{
                // open accordion
                this.setAttribute('data-open', 'true');
                this.setAccordionTextHeight(true);

                this.querySelectorAll('input').forEach(item => {
                    item.setAttribute('tabindex', '0');
                })
            }
        }
    
        closeAccordion(){
            this.setAttribute('data-open', 'false');
            this.setAccordionTextHeight();

            this.querySelectorAll('input').forEach(item => {
                item.setAttribute('tabindex', '-1');
            })
        }
    
        setAccordionTextHeight(open = false){
            if(open){
                this.textHeight = this.textInner.clientHeight;
                this.text.style.height = `calc(${this.textHeight}px + var(--accordion-extra-space, 2rem))`;
                return;
            }
    
            this.textHeight = 0;
            this.text.style.height = `${this.textHeight}px`;
        }
    }
    
    customElements.define('custom-accordion', CustomAccordion);    
}

if(!customElements.get('quantity-selector')){
    class QuantitySelector extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.btnRemoveQuantity = this.querySelector('[data-action="remove"]');
            this.btnAddQuantity = this.querySelector('[data-action="add"]');

            this.input = this.querySelector('.input-quantity');

            this.btnAddQuantity.addEventListener('click', this.addQuantity.bind(this));
            this.btnAddQuantity.addEventListener('keydown', e => {
                if(e.key === 'Enter'){
                    this.addQuantity(e);
                }
            })
            this.btnRemoveQuantity.addEventListener('click', this.removeQuantity.bind(this));
            this.btnRemoveQuantity.addEventListener('keydown', e => {
                if(e.key === 'Enter'){
                    this.removeQuantity(e);
                }
            })

            this.input.addEventListener('input', (e) => {
                this.updateProductForm(this.input.value);
            })
        }

        addQuantity(){
            if(this.input.value.trim() == "" || parseInt(this.input.value) < 0){
                this.setQuantity(1);
                return;
            }

            this.setQuantity(parseInt(this.input.value) + 1);
        }

        removeQuantity(){
            if(this.input.value.trim() == "" || parseInt(this.input.value) < 0){
                this.setQuantity(1);
                return;
            }

            this.setQuantity(parseInt(this.input.value) - 1 > 0? parseInt(this.input.value) - 1 : 1);
        }

        setQuantity(value){
            this.input.value = value;
            this.input.setAttribute('value', value);

            this.updateProductForm(value);
        }

        updateProductForm(value){
            if(this.closest('custom-featured-product, custom-product-details')){
                var wrapper = this.closest('custom-featured-product, custom-product-details');
                var productForm = wrapper.querySelector('#product-form');

                productForm.querySelector('input[name="quantity"]').value = value;
            }
        }
    }

    customElements.define('quantity-selector', QuantitySelector);
}

